<template>
    <a class="zoom-image-wrapper popup-link" :href="zoom" data-fancybox="gallery" data-caption="">
    <img class="product-slider__slide-img"
         :src="image"
         :data-zoom="zoom"
         alt="">
    </a>
</template>

<script>
import { EVENT_DETAIL_OFFER_PAGE } from '../../services/event-bus/event-types';

const { eventBus } = window.specialtyApp;
export default {
    name: 'detail-offer-image',

    data() {
        return {
            image: null,
            zoom: null,
        };
    },

    methods: {
        handler(payload) {
            this.image = payload.data.image;
            this.zoom = payload.data.zoom;
        },
    },

    created() {
        eventBus.$on(EVENT_DETAIL_OFFER_PAGE, (payload) => {
            this.handler(payload);
        });
    },
};
</script>
